<template lang="pug">
  .form-group
    label {{ label }}
    input.form-control(v-model.number="localData" :disabled="disabled" :class="{'input-error': !isValidInput()}" :placeholder="!isValidInput() ? requiredLabel : ''" @input="$emit('update:data', localData, isValidInput())" type="number")
</template>

<script>
import Base from '../base'

export default {
  extends: Base,
  accepts(property) {
    return property.type === 'integer' || property.type === 'number'
  }
}
</script>


// WEBPACK FOOTER //
// src/components/metadataeditor/template/default/Integer.vue